import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface NotificationType {
  id?: number;
  title?: string;
  body?: string;
  notification_type?: string;
  created_time?: string;
  provider_id?: number;
  provider_name?: string;
  is_seen?: string | boolean;
}

export interface notificationStateType {
  notifications: NotificationType[];
  hasNewNotifications: boolean;
}
export const initialState: notificationStateType = {
  notifications: [],
  hasNewNotifications: false,
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<NotificationType[]>) => {
      state.notifications = action.payload;
    },
    updateNotificationBadge: (state, action: PayloadAction<boolean>) => {
      state.hasNewNotifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => initialState);
  },
});

export const { setNotifications, updateNotificationBadge } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
